import React, { useEffect, useState } from "react";
import * as Yup from "yup";

import Form from "@Components/Form";
import {
  URLS,
  REMARKS_URL,
  NON_WORKING_DAY_HOLIDAY_URL,
  STATE_FETCH_URL,
} from "configs/constants";
import { fetchDataFromApi } from "utils";
import eightAxios from "configs/axiosConfig";
import { useNotifyContext } from "@Components/Notify";
import { useParams, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "@Components/ConfirmDialog";

const today = new Date();

const initialValues = {
  // status: "",
  name: "",
  date:
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate(),
  state: "",
  is_global: false,
  type_of_attendance_absent: "",
  type_of_attendance_present: "",
};

const GlobalForm = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const params = useParams();
  const [presentAttendanceType, setPresentAttendanceType] = useState([]);
  const [absentAttendanceType, setAbsentAttendanceType] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const setNotify = useNotifyContext();

  useEffect(() => {
    fetchDataFromApi(
      REMARKS_URL + "?status=Present",
      setPresentAttendanceType,
      true
    );
  }, []);

  useEffect(() => {
    fetchDataFromApi(
      REMARKS_URL + "?status=Absent",
      setAbsentAttendanceType,
      true
    );
  }, []);

  const handleSubmit = (values, { setSubmitting }) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: true,
      title: "ARE YOU SURE YOU WANT TO SAVE THIS?",
      subTitle: "YOU CANNOT UNDO THIS OPERATION.",
      onConfirm: () => {
        if (values.id === undefined) {
          eightAxios
            .post(NON_WORKING_DAY_HOLIDAY_URL, values)
            .then(() => {
              history.push(URLS.NON_WORKING_DAY_GLOBAL);
            })
            .catch((error) => {
              setNotify({
                isOpen: true,
                message: error.response.data.message,
                type: "error",
              });
              setConfirmDialog({ ...confirmDialog, isOpen: false });
              setSubmitting(false);
            });
        } else {
          eightAxios
            .patch(`${NON_WORKING_DAY_HOLIDAY_URL}${params.id}/`, values)
            .then(() => {
              history.push(URLS.NON_WORKING_DAY_GLOBAL);
            })
            .catch((error) => {
              setNotify({
                isOpen: true,
                message: error.response.data.message,
                type: "error",
              });
              setConfirmDialog({ ...confirmDialog, isOpen: false });
              setSubmitting(false);
            });
        }
      },
    });
  };
  const validationSchema = Yup.object({
    is_global: Yup.boolean().required("Global selection is required"),
    state: Yup.array()
      .when("is_global", {
        is: false, 
        then: Yup.array()
          .min(1, "No State selected")
          .required("State is required")
          .typeError("Invalid State"),
        otherwise: Yup.array().nullable(), 
      }),
  });
  const formFields = [
    {
      type: "input",
      name: "name",
      label: "Holiday Name",
      required: true,
    },
    {
      type: "datepicker",
      name: "date",
      autoComplete: "off",
      size: "small",
      label: "Date",
      required: true,
    },
    {
      type: "reactselect",
      name: "type_of_attendance_absent",
      label: "Type of Attendance (Absent)",
      required: true,
      outerOptions: absentAttendanceType,
    },
    {
      type: "reactselect",
      name: "type_of_attendance_present",
      label: "Type of Attendance (Present)",
      required: true,
      outerOptions: presentAttendanceType,
    },
    {
      type: "switch",
      name: "is_global",
      label: "Global",
      required: true,
      nolabel: false,
      yeslabel: true,
    },
    {
      type: "reactselect",
      name: "state",
      label: "State",
      required: true,
      proxyUrl: STATE_FETCH_URL,
      paginated: true,
      isMultiSelect: true,
      requiredValidation: "is_global",
      renderKey: "is_global",
      renderValue: false,
    },
  ];

  const formButtons = ["save", "cancel"];

  return (
    <div>
      <Form
        initialValues={initialValues}
        submitUrl={NON_WORKING_DAY_HOLIDAY_URL}
        outerSubmitHandler={handleSubmit}
        listRoute={URLS.NON_WORKING_DAY_GLOBAL}
        formFields={formFields}
        formButtons={formButtons}
        formTitle={t("Public Holiday")}
        validationSchema={validationSchema}

      />
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </div>
  );
};

export default GlobalForm;
